<template>
  <div class="p-4 m-0 line-height-1 font-weight-bolder bg-light theme-settings-header app-map-point-panel-header">
    <span>
      <slot>{{ header }}</slot>
    </span>
    <div class="app-map-point-panel-close" @click="close"><i class="ion ion-md-close"></i></div>
  </div>
</template>

<script>
export default {
  name: 'AppMapPointPanelHeader',
  props: {
    header: { type: String }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.app-map-point-panel {
  &-header {
    display: flex;
    align-items: center;
  }
  &-close {
    margin-left: auto;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
